import type {
  ServiceGetAllResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type {
  ExtensionInstitutionsType,
  ExtensionPersonnelType,
  FarmerInstitutionsType,
  FarmersOfFarmerGroupType
} from './types'

const KELEMBAGAAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['guest_dashboard', key] as const

const getExtensionInstitutions = (): ServiceQueryOptionType<
  ServiceGetAllResponse<ExtensionInstitutionsType>
> => ({
  queryKey: KELEMBAGAAN_QUERY_KEY('extension_institutions'),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<ExtensionInstitutionsType>
      >('/report/dashboard/kelembagaan-penyuluh')

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getExtensionPersonnel = (): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<ExtensionPersonnelType>>
> => ({
  queryKey: KELEMBAGAAN_QUERY_KEY('extension_personnel'),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<ExtensionPersonnelType>>
      >('/report/dashboard/ketenagaan-penyuluh')

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getFarmerInstitutions = (): ServiceQueryOptionType<
  ServiceGetAllResponse<FarmerInstitutionsType>
> => ({
  queryKey: KELEMBAGAAN_QUERY_KEY('farmer_institutions'),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<FarmerInstitutionsType>
      >('/report/dashboard/kelembagaan-petani')

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getFarmersOfFarmerGroup = (): ServiceQueryOptionType<
  ServiceGetAllResponse<FarmersOfFarmerGroupType>
> => ({
  queryKey: KELEMBAGAAN_QUERY_KEY('farmers_of_farmer_group'),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<FarmersOfFarmerGroupType>
      >('/report/dashboard/petani-anggota-poktan')

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const dashboard = {
  getExtensionInstitutions,
  getExtensionPersonnel,
  getFarmerInstitutions,
  getFarmersOfFarmerGroup
}
